import { render, staticRenderFns } from "./CommandsList.vue?vue&type=template&id=637353b6&"
import script from "./CommandsList.vue?vue&type=script&lang=js&"
export * from "./CommandsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommandsList.vue"
export default component.exports